import { render, staticRenderFns } from "./CreateIngredientNew.vue?vue&type=template&id=2c61b16d&scoped=true&"
import script from "./CreateIngredientNew.vue?vue&type=script&lang=js&"
export * from "./CreateIngredientNew.vue?vue&type=script&lang=js&"
import style0 from "./CreateIngredientNew.vue?vue&type=style&index=0&id=2c61b16d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c61b16d",
  null
  
)

export default component.exports